// One home for "make this stored media path loadable from anywhere".
//
// Uploaded avatars and track art are stored as relative paths (/uploads/…):
// the API host must be prefixed before an <img> can load them. Every
// consumer goes through here — the admin tabs, the leaderboards, the profile
// page and the payout screens used to carry their own copies of this line.
//
// Returns null for a missing path so callers can fall back with `??` or `||`;
// absolute, blob: and data: URLs pass through untouched.
import { SERVER_URL } from "../config";

// SERVER_URL is empty in local dev (API calls go through the CRA proxy), so
// media falls back to the production host there, exactly as before.
const MEDIA_HOST = SERVER_URL || "https://api.requesta.app";

export const absMediaUrl = (u?: string | null): string | null => {
  if (!u) return null;
  return u.startsWith("http") || u.startsWith("blob:") || u.startsWith("data:")
    ? u
    : `${MEDIA_HOST}${u}`;
};
